export default "__VITE_ASSET__Bw41ESsO__"